import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const currentVenueSlugAtom = atomWithStorage<string>(
  "munchi:current-venue",
  "",
  createJSONStorage(() => window.sessionStorage),
);
